// extracted by mini-css-extract-plugin
export var shareContainer = "share-buttons-module--share-container--Ov7F+";